import React, { useState, useContext } from 'react';
import { TextField, Autocomplete, InputAdornment, Box, Typography, Chip, Paper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { TagsContext } from '../contexts/TagsContext';
import { layoutCardRadius, layoutPillRadius } from '../theme/colors';

const SearchField = (props) => {
  const { tags } = useContext(TagsContext);
  const { value } = props

  const handleChange = (event, newValue) => {
    props.onChange(newValue); // Call the onChange callback function
  };

  return (
    <Autocomplete
      multiple
      options={tags}
      getOptionLabel={(option) => option.name}
      // disableCloseOnSelect={true}
      sx={{
        width: '100%',
        '& .MuiButtonBase-root, & .MuiButtonBase-root:hover, & .MuiButtonBase-root:active': {
          boxShadow: 'none',
        },
      }}

      /* Box com as opções */
      PaperComponent={({ children }) => (
        <Paper sx={{ width: '100%', borderRadius: layoutCardRadius, overflow: 'hidden', p: '16px 8px 16px 16px' }}>
          {children}
        </Paper>
      )}

      /* Scroll */
      ListboxProps={{
        sx: {
          height: '100%',
          overflowY: 'auto',
          paddingRight: '12px',

          /* Largura */
          '&::-webkit-scrollbar': {
            width: '4px',
          },

          /* Background */
          '&::-webkit-scrollbar-track': {
            background: 'surface.muted',
          },

          /* Cor */
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'border.subtle',
            borderRadius: layoutCardRadius,
          },

          /* Hover */
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'text.secondary',
          },
        }
      }}

      /* Tag aparece na barra de pesquisa */
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option.id}
            label={option.name}
            sx={{fontFamily: 'Nunito', fontSize: '14px', fontWeight: 400, lineHeight: '14px'}} 
          />
        ))
      }

      /* Pesquisa por tags */
      renderInput={(params) => (
        <TextField
          sx={{ width: '100%', bgcolor: 'surface.card', borderRadius: layoutPillRadius }}
          {...params}

          //label="Busca por tags"
          placeholder={value && value.length > 0 ? "" : "O que você está procurando?"}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}

      /* Opções mostradas */
      renderOption={(props, option) => (
        <Box
          {...props}
          component="li"
          sx={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px',
            '&:last-child': {
              marginBottom: 0,
            }
          }}
        >
          <Typography
            component="div"
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', fontFamily: 'Nunito', fontSize: '16px', fontWeight: 400, lineHeight: '24px' }}
          >
            <span>{option.name}</span>
            {option.usage_count > 0 && (
              <Chip
                label={option.usage_count}
                variant="outlined"
                size="small"
              />
            )}
          </Typography>
        </Box>
      )}
      value={value}
      onChange={handleChange}
    />
  );
};

export default SearchField;
